import {
  DashboardOutlined,
  UserOutlined,
  WalletOutlined,
  ShoppingCartOutlined,
  SettingOutlined,
  CloudUploadOutlined,
  TeamOutlined,
  UserAddOutlined,
  IdcardOutlined,
  LineChartOutlined,
  ApartmentOutlined,
  FundProjectionScreenOutlined,
  SubnodeOutlined,
  AppstoreOutlined,
  AppstoreAddOutlined,
  MailOutlined,
  ContainerOutlined,
  FieldTimeOutlined,
  SnippetsOutlined,
  PercentageOutlined,
  PlusCircleOutlined,
  CreditCardOutlined,
  TagsOutlined,
  DeliveredProcedureOutlined,
  SoundOutlined,
  GiftOutlined,
  FileWordOutlined,
  TrophyOutlined,
  ScheduleOutlined,
  RocketOutlined,
  AuditOutlined,
  ShoppingOutlined,
  TrademarkOutlined,
  MessageOutlined,
  BookOutlined,
  AreaChartOutlined,
  FundViewOutlined,
  CarOutlined,
  FlagOutlined,
  DropboxOutlined,
  BarsOutlined,
  ToolOutlined
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import { PERMISSIONS } from 'constants/Permissions'

const dashBoardNavTree = [
  {
    key: 'dashboard',
    path: `${APP_PREFIX_PATH}/home`,
    title: 'Dashboard',
    icon: DashboardOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.DASHBOARD.VIEW],
    submenu: [
      {
        key: 'dashboard-main',
        path: `${APP_PREFIX_PATH}/dashboard/main`,
        title: 'Dashboard',
        icon: DashboardOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.DASHBOARD.VIEW],
        submenu: []
      },
      {
        key: 'dashboard-metabase',
        path: `${APP_PREFIX_PATH}/dashboard/metabase`,
        title: 'Reports',
        icon: FundViewOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.DASHBOARD.METABASE],
        submenu: []
      },
    ]
  },
  {
    key: 'users',
    path: `${APP_PREFIX_PATH}/users`,
    title: 'User Management',
    icon: UserOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.USERS.VIEW, PERMISSIONS.ADMINS.VIEW],
    submenu: [
      {
        key: 'user-dashboard',
        path: `${APP_PREFIX_PATH}/users/dashboard`,
        title: 'Users Dashboard',
        icon: AreaChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.USERS.VIEW],
        submenu: []
      },
      {
        key: 'user-add',
        path: `${APP_PREFIX_PATH}/users/add`,
        title: 'add Administrator',
        icon: UserAddOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.ADMINS.CREATE],
        submenu: []
      },
      {
        key: 'user-getAdmins',
        path: `${APP_PREFIX_PATH}/users/admins`,
        title: 'All Admins',
        icon: IdcardOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.ADMINS.VIEW],
        submenu: []
      },
      {
        key: 'user-getAll',
        path: `${APP_PREFIX_PATH}/users/All`,
        title: 'All Client',
        icon: TeamOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.USERS.VIEW],
        submenu: []
      },
      {
        key: 'user-tools',
        path: `${APP_PREFIX_PATH}/users/tools`,
        title: 'Tools',
        icon: ToolOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.USERS.TOOLS],
        submenu: []
      }
    ]
  },
  {
    key: 'product',
    path: `${APP_PREFIX_PATH}/products`,
    title: 'Products Management',
    icon: ShoppingCartOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.PRODUCTS.VIEW],
    submenu: [
      {
        key: 'products-dashboard',
        path: `${APP_PREFIX_PATH}/products/dashboard`,
        title: 'Products Dashboard',
        icon: AreaChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PRODUCTS.VIEW],
        submenu: []
      },
      {
        key: 'product-getAll',
        path: `${APP_PREFIX_PATH}/products/all`,
        title: 'All Products',
        icon: AppstoreOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PRODUCTS.VIEW],
        submenu: []
      },
      {
        key: 'product-add',
        path: `${APP_PREFIX_PATH}/products/add`,
        title: 'add Product',
        icon: AppstoreAddOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PRODUCTS.CREATE],
        submenu: []
      },
    ]
  },
  {
    key: 'category',
    path: `${APP_PREFIX_PATH}/category`,
    title: 'Category Management',
    icon: ShoppingCartOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.CATEGORIES.VIEW],
    submenu: [
      {
        key: 'category-getAll',
        path: `${APP_PREFIX_PATH}/category/all`,
        title: 'All Category',
        icon: TagsOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.CATEGORIES.VIEW],
        submenu: []
      },
    ]
  },
  {
    key: 'promo',
    path: `${APP_PREFIX_PATH}/promo`,
    title: 'Promos Management',
    icon: ShoppingCartOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.PROMO.VIEW],
    submenu: [
      {
        key: 'promo-dashboard',
        path: `${APP_PREFIX_PATH}/promo/dashboard`,
        title: 'Promos Dashboard',
        icon: AreaChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PROMO.VIEW],
        submenu: []
      },
      {
        key: 'promo-welcome-gift',
        path: `${APP_PREFIX_PATH}/promo/welcome`,
        title: 'Welcome Gift',
        icon: SoundOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PROMO.WELCOME_GIFT_MANAGE],
        submenu: []
      },
      {
        key: 'promo-gratuity-all',
        path: `${APP_PREFIX_PATH}/promo/all`,
        title: 'All Gratuity',
        icon: GiftOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PROMO.GRATUITY_MANAGE],
        submenu: []
      },
      {
        key: 'promo-gratuity-add',
        path: `${APP_PREFIX_PATH}/promo/gratuity`,
        title: 'Add Gratuity',
        icon: GiftOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PROMO.CREATE],
        submenu: []
      },
    ]
  },
  {
    key: 'gift-card',
    path: `${APP_PREFIX_PATH}/giftCard`,
    title: 'Gift Card Management',
    icon: ShoppingCartOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.GIFT_CARDS.VIEW],
    submenu: [
      {
        key: 'giftCard-dashboard',
        path: `${APP_PREFIX_PATH}/giftCard/dashboard`,
        title: 'GiftCard Dashboard',
        icon: AreaChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.GIFT_CARDS.VIEW],
        submenu: []
      },
      {
        key: 'gift-card-all',
        path: `${APP_PREFIX_PATH}/giftCard/all`,
        title: 'Gift Card',
        icon: ShoppingOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.GIFT_CARDS.VIEW],
        submenu: []
      },
      {
        key: 'gift-card-add',
        path: `${APP_PREFIX_PATH}/giftCard/add`,
        title: 'Add Gift Card',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.GIFT_CARDS.CREATE],
        submenu: []
      },
    ]
  },
  {
    key: 'discount',
    path: `${APP_PREFIX_PATH}/discounts`,
    title: 'Discounts Management',
    icon: ShoppingCartOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.DISCOUNTS.VIEW],
    submenu: [
      {
        key: 'discount-dashboard',
        path: `${APP_PREFIX_PATH}/discounts/dashboard`,
        title: 'Discounts Dashboard',
        icon: AreaChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.DISCOUNTS.VIEW],
        submenu: []
      },
      {
        key: 'discount-getAll',
        path: `${APP_PREFIX_PATH}/discounts/all`,
        title: 'All Discounts',
        icon: PercentageOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.DISCOUNTS.VIEW],
        submenu: []
      },
      {
        key: 'discount-add',
        path: `${APP_PREFIX_PATH}/discounts/add`,
        title: 'add Discounts',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.DISCOUNTS.CREATE],
        submenu: []
      },
    ]
  },
  {
    key: 'media',
    path: `${APP_PREFIX_PATH}/media`,
    title: 'Media Management',
    icon: CloudUploadOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.MEDIA.VIEW],
    submenu: [
      {
        key: 'media',
        path: `${APP_PREFIX_PATH}/media/uploadCenter`,
        title: 'Upload Center',
        icon: CloudUploadOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.MEDIA.UPLOAD],
        submenu: []
      },
      {
        key: 'media-files',
        path: `${APP_PREFIX_PATH}/media/files`,
        title: 'Files Upload',
        icon: CloudUploadOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.MEDIA.FILES_MANAGE],
        submenu: []
      },
      {
        key: 'catalog',
        path: `${APP_PREFIX_PATH}/media/catalogUpdater`,
        title: 'Update Catalog',
        icon: BookOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.MEDIA.CATALOG_UPDATER],
        submenu: []
      },
    ]
  },
  {
    key: 'order',
    path: `${APP_PREFIX_PATH}/orders`,
    title: 'Order Management',
    icon: WalletOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.ORDERS.VIEW],
    submenu: [
      {
        key: 'order-dashboard',
        path: `${APP_PREFIX_PATH}/orders/dashboard`,
        title: 'Orders Dashboard',
        icon: AreaChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.ORDERS.VIEW],
        submenu: []
      },
      {
        key: 'order-all',
        path: `${APP_PREFIX_PATH}/orders/all`,
        title: 'Order Management',
        icon: WalletOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.ORDERS.VIEW],
        submenu: []
      },
      {
        key: 'order-command',
        path: `${APP_PREFIX_PATH}/orders/command`,
        title: 'Command Management',
        icon: SnippetsOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.ORDERS.EXPORT_BON_COMMAND],
        submenu: []
      },
      {
        key: 'order-delivery',
        path: `${APP_PREFIX_PATH}/orders/delivery`,
        title: 'Delivery Management',
        icon: FieldTimeOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.ORDERS.VIEW],
        submenu: []
      },
      {
        key: 'order-invoice',
        path: `${APP_PREFIX_PATH}/orders/invoice`,
        title: 'Payment Management',
        icon: ContainerOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.INVOICES.VIEW],
        submenu: []
      },
      {
        key: 'delivery-tracker',
        path: `${APP_PREFIX_PATH}/orders/tracker`,
        title: 'Delivery Tracker',
        icon: CarOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.ORDERS.VIEW],
        submenu: []
      },
    ]
  },
  {
    key: 'bonusTransaction',
    path: `${APP_PREFIX_PATH}/bonus`,
    title: 'Bonus Management',
    icon: SettingOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.BONUS.DASHBOARD],
    submenu: [
      {
        key: 'bonus-dashboard',
        path: `${APP_PREFIX_PATH}/bonus/dashboard`,
        title: 'Bonus Dashboard',
        icon: AreaChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.BONUS.DASHBOARD],
        submenu: []
      },
      {
        key: 'bonusTransaction-grad',
        path: `${APP_PREFIX_PATH}/bonus/grad`,
        title: 'Bonus Level',
        icon: ApartmentOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.BONUS.LEVEL],
        submenu: []
      },
      {
        key: 'bonusTransaction-gen',
        path: `${APP_PREFIX_PATH}/bonus/generation`,
        title: 'Bonus affiliation',
        icon: SubnodeOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.BONUS.GENERATION],
        submenu: []
      },
      {
        key: 'bonusTransaction-drop',
        path: `${APP_PREFIX_PATH}/bonus/drop`,
        title: 'Bonus DropShipping',
        icon: ShoppingCartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.BONUS.DROPSHIPPING],
        submenu: []
      },
      {
        key: 'bonusTransaction-restore',
        path: `${APP_PREFIX_PATH}/bonus/restore`,
        title: 'Bonus restoration',
        icon: DeliveredProcedureOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.BONUS.RESTORE],
        submenu: []
      },
      {
        key: 'bonusTransaction-coaching',
        path: `${APP_PREFIX_PATH}/bonus/coaching`,
        title: 'Bonus Coaching',
        icon: RocketOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.BONUS.COACHING],
        submenu: []
      },
    ]
  },
  {
    key: 'settings',
    path: `${APP_PREFIX_PATH}/settings`,
    title: 'Settings Management',
    icon: SettingOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.SETTINGS.VIEW],
    submenu: [
      {
        key: 'settings-all',
        path: `${APP_PREFIX_PATH}/settings`,
        title: 'Settings Management',
        icon: SettingOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.SETTINGS.VIEW],
        submenu: []
      },
    ]
  },
  {
    key: 'Reglement',
    path: `${APP_PREFIX_PATH}/reglement`,
    title: 'Reglement Management',
    icon: TrademarkOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.REGLEMENT.VIEW],
    submenu: [
      {
        key: 'Reglement-add',
        path: `${APP_PREFIX_PATH}/reglement/add`,
        title: 'add Reglement',
        icon: FundProjectionScreenOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.REGLEMENT.CREATE],
        submenu: []
      },
      {
        key: 'Reglement-list',
        path: `${APP_PREFIX_PATH}/reglement/list`,
        title: 'list Reglement',
        icon: TrademarkOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.REGLEMENT.VIEW],
        submenu: [],
      }
    ]
  },
  {
    key: 'finance',
    path: `${APP_PREFIX_PATH}/finance`,
    title: 'Finance Management',
    icon: SnippetsOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.FINANCE.VIEW],
    submenu: [
      {
        key: 'finance-dashboard',
        path: `${APP_PREFIX_PATH}/finance/dashboard`,
        title: 'Finance Dashboard',
        icon: AreaChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.FINANCE.VIEW],
        submenu: []
      },
      {
        key: 'finance-sales',
        path: `${APP_PREFIX_PATH}/finance/sales`,
        title: 'state of sales',
        icon: LineChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.FINANCE.VIEW_REPORTS],
        submenu: []
      },
      {
        key: 'export-rs',
        path: `${APP_PREFIX_PATH}/reglement/rs`,
        title: 'export RS',
        icon: FileWordOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.REGLEMENT.EXPORT],
        submenu: []
      },
    ]
  },
  {
    key: 'challenge',
    path: `${APP_PREFIX_PATH}/challenge`,
    title: 'Challenges Management',
    icon: TrophyOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.CHALLENGES.VIEW],
    submenu: [
      {
        key: 'challenge-dashboard',
        path: `${APP_PREFIX_PATH}/challenge/dashboard`,
        title: 'Challenges Dashboard',
        icon: AreaChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.CHALLENGES.VIEW],
        submenu: []
      },
      {
        key: 'challenge-all',
        path: `${APP_PREFIX_PATH}/challenge/all`,
        title: 'Challenges List',
        icon: TrophyOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.CHALLENGES.VIEW],
        submenu: []
      },
      {
        key: 'challenge-add',
        path: `${APP_PREFIX_PATH}/challenge/add`,
        title: 'Add Challenge',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.CHALLENGES.CREATE],
        submenu: []
      },
    ]
  },
  {
    key: 'formation',
    path: `${APP_PREFIX_PATH}/formations`,
    title: 'Arbio Training',
    icon: ShoppingCartOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.FORMATIONS.VIEW],
    submenu: [
      {
        key: 'formation-getAll',
        path: `${APP_PREFIX_PATH}/formations/all`,
        title: 'All formation',
        icon: AppstoreOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.FORMATIONS.VIEW],
        submenu: []
      },
      {
        key: 'formation-add',
        path: `${APP_PREFIX_PATH}/formations/add`,
        title: 'add Formation',
        icon: AppstoreAddOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.FORMATIONS.CREATE],
        submenu: []
      },
      {
        key: 'formation-tickets',
        path: `${APP_PREFIX_PATH}/formations/tickets`,
        title: 'Ticket Formation',
        icon: ScheduleOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.FORMATIONS.TICKETS_VIEW],
        submenu: []
      },
    ]
  },
  {
    key: 'payment',
    path: `${APP_PREFIX_PATH}/payments`,
    title: 'Payment Management',
    icon: ShoppingCartOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.PAYMENTS.VIEW],
    submenu: [
      {
        key: 'payments-dashboard',
        path: `${APP_PREFIX_PATH}/payments/dashboard`,
        title: 'Payments Dashboard',
        icon: AreaChartOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PAYMENTS.VIEW],
        submenu: []
      },
      {
        key: 'payment-getAll',
        path: `${APP_PREFIX_PATH}/payments/all`,
        title: 'All Payments',
        icon: CreditCardOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PAYMENTS.VIEW],
        submenu: []
      },
      {
        key: 'payment-get-wallet',
        path: `${APP_PREFIX_PATH}/payments/wallet`,
        title: 'Wallet Payments',
        icon: WalletOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PAYMENTS.VIEW],
        submenu: []
      },
      {
        key: 'payment-method',
        path: `${APP_PREFIX_PATH}/payments/methods`,
        title: 'Payment methods',
        icon: AuditOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PAYMENTS.METHODS_VIEW],
        submenu: []
      }
    ]
  },
  {
    key: 'notification',
    path: `${APP_PREFIX_PATH}/notifications`,
    title: 'Notification Management',
    icon: MailOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.NOTIFICATIONS.VIEW],
    submenu: [
      {
        key: 'notification-getAll',
        path: `${APP_PREFIX_PATH}/notifications/all`,
        title: 'All Notifications',
        icon: MailOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.NOTIFICATIONS.VIEW],
        submenu: []
      },
      {
        key: 'notification-send',
        path: `${APP_PREFIX_PATH}/notifications/send`,
        title: 'Send Notification',
        icon: MessageOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.NOTIFICATIONS.SEND],
        submenu: []
      },
    ]
  },
  {
    key: 'providers',
    path: `${APP_PREFIX_PATH}/providers`,
    title: 'Provider Management',
    icon: MailOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.PROVIDERS.VIEW],
    submenu: [
      {
        key: 'providers-getAll',
        path: `${APP_PREFIX_PATH}/providers/all`,
        title: 'All Providers',
        icon: MailOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PROVIDERS.VIEW],
        submenu: []
      },
      {
        key: 'add-provider',
        path: `${APP_PREFIX_PATH}/providers/add`,
        title: 'Add Provider',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.PROVIDERS.CREATE],
        submenu: []
      },
    ]
  },
  {
    key: 'survey',
    path: `${APP_PREFIX_PATH}/survey`,
    title: 'Survey Management',
    icon: MailOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.SURVEYS.VIEW],
    submenu: [
      {
        key: 'survey-getAll',
        path: `${APP_PREFIX_PATH}/survey/list`,
        title: 'All Surveys',
        icon: MailOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.SURVEYS.VIEW],
        submenu: []
      },
      {
        key: 'survey-add',
        path: `${APP_PREFIX_PATH}/survey/add`,
        title: 'Add Survey',
        icon: MessageOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.SURVEYS.CREATE],
        submenu: []
      },
      {
        key: 'survey-settings',
        path: `${APP_PREFIX_PATH}/survey/settings`,
        title: 'Survey settings',
        icon: MessageOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.SURVEYS.EDIT],
        submenu: []
      }
    ]
  },
  {
    key: 'international',
    path: `${APP_PREFIX_PATH}/international`,
    title: 'International Management',
    icon: MailOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.INTERNATIONAL.LANGUAGE_VIEW, PERMISSIONS.INTERNATIONAL.CURRENCY_VIEW],
    submenu: [
      {
        key: 'language-settings',
        path: `${APP_PREFIX_PATH}/international/language`,
        title: 'Language List',
        icon: MessageOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.INTERNATIONAL.LANGUAGE_VIEW],
        submenu: []
      },
      {
        key: 'currency-settings',
        path: `${APP_PREFIX_PATH}/international/currency`,
        title: 'Currency List',
        icon: MessageOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.INTERNATIONAL.CURRENCY_VIEW],
        submenu: []
      }
    ]
  },
  {
    key: 'countries',
    path: `${APP_PREFIX_PATH}/countries`,
    title: 'Countries',
    icon: FlagOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.COUNTRIES_SETTINGS.VIEW],
    submenu: [
      {
        key: 'countries-getAll',
        path: `${APP_PREFIX_PATH}/countries/all`,
        title: 'All Countries',
        icon: FlagOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.COUNTRIES_SETTINGS.VIEW],
        submenu: []
      }
    ]
  },
  {
    key: 'carriers',
    path: `${APP_PREFIX_PATH}/carriers`,
    title: 'Carriers',
    icon: DropboxOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.CARRIERS.VIEW],
    submenu: [
      {
        key: 'carriers-getAll',
        path: `${APP_PREFIX_PATH}/carriers/all`,
        title: 'All Carriers',
        icon: DropboxOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.CARRIERS.VIEW],
        submenu: []
      },
      {
        key: 'add-carriers',
        path: `${APP_PREFIX_PATH}/carriers/add`,
        title: 'Add Carriers',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.CARRIERS.CREATE],
        submenu: []
      },
      // {
      //   key: 'carriers-logs',
      //   path: `${APP_PREFIX_PATH}/carriers/logs`,
      //   title: 'Carriers Log',
      //   icon: FileTextOutlined,
      //   breadcrumb: false,
      //   submenu: []
      // },
    ]
  },
  {
    key: 'logs',
    path: `${APP_PREFIX_PATH}/logs`,
    title: 'sidebar.action_logs',
    icon: BarsOutlined,
    breadcrumb: false,
    permission: [PERMISSIONS.LOGS.VIEW],
    submenu: [
      {
        key: 'logs-getAll',
        path: `${APP_PREFIX_PATH}/logs`,
        title: 'All Logs',
        icon: BarsOutlined,
        breadcrumb: false,
        permission: [PERMISSIONS.LOGS.VIEW],
        submenu: []
      },
    ]
  },
]

const navigationConfig = [
  ...dashBoardNavTree
]

export default navigationConfig;
